import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { SplitReveal } from "./Motion";
import { EASE } from "../../lib/scroll";

export const Audience = () => {
  const { t } = useLang();
  const a = t.audience;
  return (
    <section id="clienti" data-testid="audience-section" className="grain relative overflow-hidden bg-[#0a0a0b] py-28 text-[#fafaf7] md:py-40">
      <div className="pointer-events-none absolute -left-40 top-20 h-[500px] w-[500px] rounded-full bg-[#d4af37]/10 blur-[140px]" />
      <div className="wrap relative">
        <div className="mb-16 grid gap-6 md:mb-24 md:grid-cols-12">
          <p className="eyebrow md:col-span-3">{a.eyebrow}</p>
          <h2 className="font-display text-4xl font-bold tracking-tight sm:text-6xl lg:text-7xl md:col-span-9">
            <SplitReveal key={a.title} text={a.title} />
          </h2>
        </div>
        <div className="border-b border-white/10">
          {a.items.map((it, i) => (
            <motion.div
              key={it.title}
              data-testid={`audience-row-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 0.9, ease: EASE, delay: i * 0.08 }}
              className="group relative grid cursor-default gap-4 border-t border-white/10 py-10 md:grid-cols-12 md:items-center md:py-12"
            >
              <span className="absolute inset-x-0 top-0 h-px origin-left scale-x-0 bg-[#d4af37] transition-transform duration-700 group-hover:scale-x-100" />
              <span className="font-mono text-xs tracking-[0.3em] text-[#d4af37] md:col-span-1">0{i + 1}</span>
              <h3 className="font-display text-2xl font-bold tracking-tight transition-transform duration-700 group-hover:translate-x-3 sm:text-3xl lg:text-4xl md:col-span-6">{it.title}</h3>
              <p className="text-sm leading-relaxed text-white/55 md:col-span-4 md:text-base">{it.desc}</p>
              <ArrowUpRight className="hidden h-6 w-6 justify-self-end text-white/30 transition-[color,transform] duration-500 group-hover:rotate-45 group-hover:text-[#e8c979] md:col-span-1 md:block" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
